import { render, staticRenderFns } from "./TicketFormStep.vue?vue&type=template&id=ce0124fc"
import script from "./TicketFormStep.vue?vue&type=script&lang=js"
export * from "./TicketFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/vercel/path0/components/common/Input.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default,Label: require('/vercel/path0/components/common/Label.vue').default})
